// Global styles cho toàn bộ ứng dụng - Theme xanh đen chuyên nghiệp
export const colors = {
    // Primary - Xanh dương sáng
    primary: {
        main: '#00D9FF',      // Cyan sáng - màu chính
        light: '#5FE3FF',     // Cyan nhạt hơn
        dark: '#00A8CC',      // Cyan đậm
        contrastText: '#0A1929',
    },
    
    // Secondary - Tím xanh
    secondary: {
        main: '#7C3AED',      // Tím xanh
        light: '#A78BFA',     // Tím nhạt
        dark: '#5B21B6',      // Tím đậm
        contrastText: '#FFFFFF',
    },
    
    // Background - Xanh đen chủ đạo
    background: {
        default: '#0A1929',   // Xanh đen chính (nền tối nhất)
        paper: '#132F4C',     // Xanh đen nhạt hơn (cho card, paper)
        dark: '#050E18',      // Xanh đen đậm nhất
        light: '#1A2E3E',     // Xanh đen sáng hơn
    },
    
    // Text colors
    text: {
        primary: '#FFFFFF',        // Trắng cho text chính
        secondary: '#B2BAC2',      // Xám xanh cho text phụ
        disabled: '#5A6C7D',       // Xám đậm cho disabled
        hint: '#7A8A9A',          // Xám nhạt cho hint
    },
    
    // Status colors
    success: {
        main: '#00E676',      // Xanh lá sáng
        light: '#69F0AE',
        dark: '#00C853',
        contrastText: '#0A1929',
    },
    
    error: {
        main: '#FF5252',      // Đỏ sáng
        light: '#FF8A80',
        dark: '#FF1744',
        contrastText: '#FFFFFF',
    },
    
    warning: {
        main: '#FFD600',      // Vàng sáng
        light: '#FFEA00',
        dark: '#FFC400',
        contrastText: '#0A1929',
    },
    
    info: {
        main: '#00B8D4',      // Xanh dương nhạt
        light: '#00E5FF',
        dark: '#0091EA',
        contrastText: '#FFFFFF',
    },
    
    // Divider
    divider: 'rgba(255, 255, 255, 0.12)',
    
    // Action states
    action: {
        active: '#FFFFFF',
        hover: 'rgba(255, 255, 255, 0.08)',
        selected: 'rgba(0, 217, 255, 0.16)',
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
    },
    
    // Gradient backgrounds
    gradient: {
        primary: 'linear-gradient(135deg, #00D9FF 0%, #7C3AED 100%)',
        secondary: 'linear-gradient(135deg, #7C3AED 0%, #00D9FF 100%)',
        dark: 'linear-gradient(180deg, #0A1929 0%, #132F4C 100%)',
        light: 'linear-gradient(180deg, #132F4C 0%, #1A2E3E 100%)',
    },
    
    // Shades of dark blue
    darkBlue: {
        50: '#E3F2FD',
        100: '#BBDEFB',
        200: '#90CAF9',
        300: '#64B5F6',
        400: '#42A5F5',
        500: '#2196F3',
        600: '#1E88E5',
        700: '#1976D2',
        800: '#132F4C',
        900: '#0A1929',
    },
    
    // Additional utility colors
    white: '#FFFFFF',
    black: '#000000',
    
    // Gray scale adapted for dark theme
    gray: {
        50: '#F8FAFC',
        100: '#F1F5F9',
        200: '#E2E8F0',
        300: '#CBD5E1',
        400: '#94A3B8',
        500: '#64748B',
        600: '#475569',
        700: '#334155',
        800: '#1E293B',
        900: '#0F172A',
    },
};

export const spacing = {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
};

export const breakpoints = {
    xs: '0px',
    sm: '600px',
    md: '900px',
    lg: '1200px',
    xl: '1536px',
};

export const shadows = {
    sm: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    md: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    lg: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    xl: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
};
